export class Message {
    constructor(props) {
        Object.assign(this, props);
    }
}
export const MessageType = {
    Ok: 'ok',
    Error: 'error',
    Warning: 'warning',
};
export class LoaderData {
    constructor(props) {
        Object.assign(this, props);
    }
}



//////////////////
// WEBPACK FOOTER
// ./src/modules/UI/Model.ts
// module id = 149
// module chunks = 0